import type {
  DiscussionLanguage,
  DiscussionLanguageFilter,
  DiscussionLanguageOption,
} from "./types";
import {
  APP_LANGUAGE_FILTER_OPTIONS,
  APP_LANGUAGE_OPTIONS,
} from "../shared/languageOptions";

export const DISCUSSION_LANGUAGES: readonly DiscussionLanguage[] = ["en", "de"];

export const DISCUSSION_LANGUAGE_OPTIONS: DiscussionLanguageOption<DiscussionLanguage>[] =
  APP_LANGUAGE_OPTIONS.map((option) => ({ ...option }));

export const DISCUSSION_LANGUAGE_FILTER_OPTIONS: DiscussionLanguageOption<DiscussionLanguageFilter>[] =
  APP_LANGUAGE_FILTER_OPTIONS.map((option) => ({ ...option }));

const discussionLanguageValueSet = new Set<string>(DISCUSSION_LANGUAGES);

export function isDiscussionLanguage(
  value: string,
): value is DiscussionLanguage {
  return discussionLanguageValueSet.has(value);
}

export function isDiscussionLanguageFilter(
  value: string,
): value is DiscussionLanguageFilter {
  return value === "all" || isDiscussionLanguage(value);
}
